<template>
      <!-- 自定义输入框 -->
      <div class="flex border items-start pl-[5px] pr-[5px] w-[100%] flex-wrap min-h-[40px] py-[8px] mobile-tag-container" :class="{ 'border-red-500': isInvalid }" @click="focusInput">
        <!-- 标签列表 -->
        <el-tag
          v-for="(tag, index) in tags"
          :key="index"
          closable
          @close="handleCloseTag(index)"
          class="mr-[5px] mb-[5px] mobile-tag"
          size="small"
        >
          {{ tag }}
        </el-tag>
  
        <!-- 输入框 -->
        <input
          v-model="inputValue"
          ref="inputRef"
          placeholder="多个关键字请用回车隔开"
          @keyup.enter="handleAddTag"
          @blur="handleAddTag"
          class="inline-input mobile-input-field"
          noStyle
        />
        <el-icon class="cursor-pointer mobile-close-icon" v-if="tags.length > 0"><CircleClose @click="handleAllCloseTag" /></el-icon>
      </div>
  </template>
  
<script setup lang="ts">
import { ref, nextTick, defineEmits, defineProps, watch, toRefs } from "vue";
const emit = defineEmits(['update:modelValue']);

const props = defineProps({
  isInvalid: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: Array,
    default: () => []
  }
});

const { modelValue } = toRefs(props);
const inputValue = ref(""); // 输入框的绑定值
const tags = ref<string[]>([]); // 存储标签的数组
const inputRef = ref<HTMLInputElement | null>(null); // 输入框的引用 

watch(modelValue, (newValue) => {
  tags.value = [...(newValue as string[])];
}, { immediate: true, deep: true });

// 添加标签
const handleAddTag = () => {
    const trimmedValue = inputValue.value.trim();
    if (trimmedValue !== "" && !tags.value.includes(trimmedValue)) {
        tags.value.push(trimmedValue);
        emit('update:modelValue', tags.value);
        inputValue.value = ""; // 清空输入框
        focusInput(); // 重新聚焦到输入框
    }
};

// 删除标签
const handleCloseTag = (index: number) => {
    tags.value.splice(index, 1);
    emit('update:modelValue', tags.value);
};

// 删除所有标签
const handleAllCloseTag = () => {
    tags.value = [];
    emit('update:modelValue', tags.value);
};

// 聚焦到输入框
const focusInput = () => {
    nextTick(() => {
        if (inputRef.value) {
          inputRef.value.focus();
        }
    });
};
  

  </script>
  
  <style scoped>
  .mobile-tag-container {
    border-radius: 4px;
    transition: border-color 0.2s;
  }
  
  .mobile-tag-container:hover {
    border-color: #409eff;
  }
  
  .mobile-tag {
    font-size: 12px;
    padding: 4px 8px;
  }
  
  .inline-input {
    flex-grow: 1;
    min-width: 100px;
    border: none !important;
    outline: none !important;
    font-size: 14px;
    padding: 0 4px;
    line-height: 24px;
    height: 24px;
    align-self: center;
  }
  
  .inline-input::placeholder {
    color: #c0c4cc;
    font-size: 14px;
    line-height: 24px;
  }
  
  .mobile-input-field {
    min-width: 80px;
  }
  
  .mobile-close-icon {
    font-size: 16px;
    color: #909399;
    margin-left: 4px;
  }
  
  /* 移动端适配 */
  @media (max-width: 768px) {
    .mobile-tag-container {
      min-height: 40px;
      padding: 8px;
    }
    
    .mobile-tag {
      font-size: 11px;
      padding: 3px 6px;
      margin-right: 4px;
      margin-bottom: 4px;
    }
    
    .inline-input {
      font-size: 13px;
      padding: 0 2px;
      min-width: 60px;
      line-height: 22px;
      height: 22px;
    }
    
    .inline-input::placeholder {
      font-size: 13px;
      line-height: 22px;
    }
    
    .mobile-close-icon {
      font-size: 14px;
    }
  }
  </style>